var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.userName))]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"0.2rem"}},[_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":_vm.getUserName}},[_vm._v("获取姓名")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67b2d298","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ysy/WorkWeiXinAuthShow.vue
// module id = null
// module chunks = 